module.exports = __webpack_public_path__ + "img/位图@2x.f0e2fe75.png";